<app-dev-tools-section title="Project Data" storageKey="data">
  <!-- Quota Information -->
  @if (quotaInfo(); as info) {
    <div class="mb-2 rounded bg-hover px-2 py-1.5 text-xs">
      <div class="flex justify-between">
        <span>Locations:</span>
        <span class="font-medium">{{ locations()?.length ?? 0 }}</span>
      </div>
      <div class="flex justify-between">
        <span>Departments:</span>
        <span class="font-medium"
          >{{ info.departments.current }}/{{ info.departments.limit === Infinity ? '∞' : info.departments.limit }}</span
        >
      </div>
      <div class="flex justify-between">
        <span>Teams:</span>
        <span class="font-medium"
          >{{ info.teams.current }}/{{ info.teams.limit === Infinity ? '∞' : info.teams.limit }}</span
        >
      </div>
      <div class="flex justify-between">
        <span>Employees:</span>
        <span class="font-medium"
          >{{ info.employees.current }}/{{
            info.employees.limit === Infinity || info.employees.limit === UNLIMITED_QUOTA ? '∞' : info.employees.limit
          }}</span
        >
      </div>
    </div>
  }

  <!-- Project Scaffolding -->
  <div class="mb-3">
    <h4 class="mb-1.5 text-xs font-medium">Project Scaffolding</h4>
    <div class="flex flex-wrap gap-2">
      <button sb-button size="sm" (click)="scaffoldProject('small')" [disabled]="isLoading()">Small</button>
      <button sb-button size="sm" (click)="scaffoldProject('medium')" [disabled]="isLoading()">Medium</button>
      <button sb-button size="sm" (click)="scaffoldProject('large')" [disabled]="isLoading()">Large</button>
      <button sb-button size="sm" (click)="scaffoldProject('megaCorp')" [disabled]="isLoading()">Mega corp</button>
    </div>
  </div>

  <!-- Individual Entity Generation -->
  <div class="mb-3">
    <h4 class="mb-1.5 text-xs font-medium">Hydration</h4>

    <!-- Amount Selector -->
    <div class="mb-3">
      <label class="mb-1 block text-xs text-subtle">Amount: {{ entityCount() }}</label>
      <input type="range" min="1" max="999" [(ngModel)]="entityCount" class="w-full" [disabled]="isLoading()" />
      <div class="mt-0.5 flex justify-between text-xs text-subtle">
        <span>1</span>
        <span>999</span>
      </div>
    </div>

    <!-- Entity Toggles -->
    <div class="mb-3 grid grid-cols-2">
      <label
        class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs transition-colors hover:bg-hover"
        [class.bg-hover]="generateLocations()"
        [class.font-medium]="generateLocations()"
      >
        <input type="checkbox" [(ngModel)]="generateLocations" class="size-3" [disabled]="isLoading()" />
        <span>Locations</span>
      </label>

      <label
        class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs transition-colors hover:bg-hover"
        [class.bg-hover]="generateDepartments()"
        [class.font-medium]="generateDepartments()"
      >
        <input type="checkbox" [(ngModel)]="generateDepartments" class="size-3" [disabled]="isLoading()" />
        <span>Departments</span>
      </label>

      <label
        class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs transition-colors hover:bg-hover"
        [class.bg-hover]="generateTeams()"
        [class.font-medium]="generateTeams()"
      >
        <input type="checkbox" [(ngModel)]="generateTeams" class="size-3" [disabled]="isLoading()" />
        <span>Teams</span>
      </label>

      <label
        class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs transition-colors hover:bg-hover"
        [class.bg-hover]="generateEmployees()"
        [class.font-medium]="generateEmployees()"
      >
        <input type="checkbox" [(ngModel)]="generateEmployees" class="size-3" [disabled]="isLoading()" />
        <span>Employees</span>
      </label>

      <label
        class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs transition-colors hover:bg-hover"
        [class.bg-hover]="generateShiftTemplates()"
        [class.font-medium]="generateShiftTemplates()"
      >
        <input type="checkbox" [(ngModel)]="generateShiftTemplates" class="size-3" [disabled]="isLoading()" />
        <span>Shift templates</span>
      </label>

      <label
        class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs transition-colors hover:bg-hover"
        [class.bg-hover]="generateScheduledShifts()"
        [class.font-medium]="generateScheduledShifts()"
      >
        <input type="checkbox" [(ngModel)]="generateScheduledShifts" class="size-3" [disabled]="isLoading()" />
        <span>Shifts</span>
      </label>

      <label
        class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs transition-colors hover:bg-hover"
        [class.bg-hover]="generateTimesheets()"
        [class.font-medium]="generateTimesheets()"
      >
        <input type="checkbox" [(ngModel)]="generateTimesheets" class="size-3" [disabled]="isLoading()" />
        <span>Timesheets</span>
      </label>

      <label
        class="flex cursor-pointer items-center gap-1.5 rounded px-2 py-1 text-xs transition-colors hover:bg-hover"
        [class.bg-hover]="generateAbsences()"
        [class.font-medium]="generateAbsences()"
      >
        <input type="checkbox" [(ngModel)]="generateAbsences" class="size-3" [disabled]="isLoading()" />
        <span>Absences</span>
      </label>
    </div>

    <!-- Generate Button -->
    <button sb-button size="sm" [disabled]="isLoading()" class="w-full" (click)="generateEntities()">
      Generate Entities
    </button>
  </div>

  @if (isLoading()) {
    <p class="mt-2 text-xs text-subtle">{{ loadingMessage() }}</p>
  }
</app-dev-tools-section>
